import { render, staticRenderFns } from "./uplodeInput.vue?vue&type=template&id=4fe6cd9f&scoped=true&"
import script from "./uplodeInput.vue?vue&type=script&lang=js&"
export * from "./uplodeInput.vue?vue&type=script&lang=js&"
import style0 from "./uplodeInput.vue?vue&type=style&index=0&id=4fe6cd9f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe6cd9f",
  null
  
)

export default component.exports